import {
  TipTapEditor
} from "./chunks/chunk-N65643ET.js";
import "./chunks/chunk-6SFA2MXG.js";
import "./chunks/chunk-ZIALNMQA.js";
import "./chunks/chunk-JXW4QBHT.js";
import "./chunks/chunk-VKKS3DJ7.js";
import "./chunks/chunk-EVXZQBVO.js";
import "./chunks/chunk-V3GVM5MU.js";
import "./chunks/chunk-4GVZRMD6.js";
import "./chunks/chunk-4KYHEDOE.js";
import "./chunks/chunk-SKV74KKH.js";
import "./chunks/chunk-Y7ECDMDC.js";
import "./chunks/chunk-3NKMRE2U.js";
import "./chunks/chunk-A74VX7XC.js";
import "./chunks/chunk-4EN52UIW.js";
import "./chunks/chunk-UPXIGH7W.js";
import "./chunks/chunk-CNIINXXE.js";
import "./chunks/chunk-M5MRCAAY.js";
import "./chunks/chunk-OCUMPVMV.js";
import "./chunks/chunk-3FY26PZX.js";
import "./chunks/chunk-NYA57RY3.js";
import "./chunks/chunk-YXKZT3DD.js";
import "./chunks/chunk-4PTK2Z3Z.js";
import {
  AttachmentManager
} from "./chunks/chunk-RJ7J34WH.js";
import "./chunks/chunk-H7IBPZ6Z.js";
import "./chunks/chunk-KPIYU2DV.js";
import "./chunks/chunk-PA75CBW2.js";
import "./chunks/chunk-A753ZYET.js";
import "./chunks/chunk-76S5BEJL.js";
import "./chunks/chunk-4HL6XB2M.js";
import "./chunks/chunk-54KOYG5C.js";

// src/exports/index.ts
TipTapEditor.define();
export {
  AttachmentManager,
  TipTapEditor
};
//# sourceMappingURL=index.js.map
